"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _promoLabel = _interopRequireDefault(require("./promoLabel.proptypes"));

var _constant = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "PromoLabel__PromoContainer",
  componentId: "sc-3ll542-0"
})(["display:flex;justify-content:center;align-items:center;padding:", ";line-height:", ";border-radius:", ";background:linear-gradient(109.06deg,#ff6767 -5.45%,#a73a3a 43.47%,#8c0087 90.86%);"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.lineHeight.XXLarge);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.borderRadius.normal);
});

var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "PromoLabel__LabelContainer",
  componentId: "sc-3ll542-1"
})(["padding-left:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.micro);
});

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "PromoLabel__IconContainer",
  componentId: "sc-3ll542-2"
})(["display:flex;align-items:center;"]);

var PromoLabel = function PromoLabel(_ref5) {
  var theme = _ref5.theme,
      icon = _ref5.icon,
      label = _ref5.label,
      translation = _ref5.translation;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    theme: theme,
    color: _constant.ICON_TYPE.default.color,
    fontsize: _constant.ICON_TYPE.default.size,
    icon: icon
  })), /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant.TEXT_TYPE.default.type,
    color: _constant.TEXT_TYPE.default.color
  }, language[label]))));
};

PromoLabel.propTypes = _promoLabel.default.PropTypes;
PromoLabel.defaultProps = _promoLabel.default.DefaultProps;
var _default = PromoLabel;
exports.default = _default;